import * as React from 'react';
import './icon.scss';

export const Home = () => (
  <svg
    className="cpp-ui-icon cpp-icon-home"
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="6" fill="#0052d6" />
    <g clipPath="url(#clip0_5475_34897)">
      <path
        d="M7.2 11.1984V8.79844H8.8V11.1984H10.8V7.99844H12L8 4.39844L4 7.99844H5.2V11.1984H7.2Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5475_34897">
        <rect
          width="9.6"
          height="9.6"
          fill="white"
          transform="translate(3.2 3.2)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const EvolvingInsights = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect
      x="0.734833"
      y="7.98737"
      width="16"
      height="17.6"
      transform="rotate(-29.0283 0.734833 7.98737)"
      fill="url(#pattern0_509_7994)"
    />
    <defs>
      <pattern
        id="pattern0_509_7994"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_509_7994" transform="scale(0.01 0.00909091)" />
      </pattern>
      <image
        id="image0_509_7994"
        width="100"
        height="110"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABuCAYAAADRebYyAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAZKADAAQAAAABAAAAbgAAAABlC8bgAAAIGklEQVR4Ae2c0XHjNhCG7ZsUoExSAEuQKzDdgfych5Mq8LkCjyvwqYKTH/J86sB0BVYJKiCZqIPk/21QoWgSCxAAJZG7MziA3MUS2I8LkJJ1FxcqGoFzjMDfv//xA2WeeuyXqS8wBP+EgXnMzVwWv/3158q0o1cKRAhpDUZpnQyKAilD3FC3wCgtk0BRIGV4a7UAo7SODkWBlKGt1I4wyh5RoXwpvWp9EIHXgyP7QdSnL82QlmAjS+ZQ8enKVaJkigKxhPsYUBSIBQhVfUNRIAKQvqEoEAcgfUJRII5A+oKiQDyA9AFFgXgCSQ1FgXQAkhKKAukIJBUUBRIAJAUUBRIIJDYUBRIBSEwoCiQSkFhQogDB5z05BsRyjZKZgkrFIQIHnxJ3BgIIU1zsDmWGMnG4sJq0R2APxRuIyYYH+M7b/aumQwTeoTgDAYgMF3lCYUaopInA4hcXv4BBCPz2TJcml4AF2IjfqQMGs+KnwgiIsltXeckCDGbF3M2fWgVEQN7UFUZAeP267mGwW+MeYpapuZ/fd+sN/i1QXlF2KBf4O9iC9RgEcZtjnlziXffaAxiM0aenLDid4Tz3DFdh4FcoSwR/i3qUYmBwiXeVTzDY8QAInGY494biSngN2/sxg8D8o/5lSn3Jck03ZgVBrFCPWmJlRhnEfYbAcY6TL6XCUhPGDWBsLDajUMWGwaBV30MeHKKoMEyQUsDYA4HzKQ5ycy1bxWVKMyPh3/2WGXJno2B0a90z4m7gTTEvN/VZk7JyjkvVfeW4tWlS+SsM8ppRgePnc4aaapmqxukSF8lxQtrMvyOQViDwk8EP31+4/NmES94t/G1tRqem6wMG58wlK2dDkKVNb2Dw/UWCQTe0eTN9eHzy0hcMBoJAroWIbBzuZmbGRPBTVdOWfU5e+oTBYBBIxoZFCouufEt1yYy6m6mZbP38yRz3DYMTdwHyKkSIG3hXCenb9ZpO/Y4BgwMjEEl2gkEu6G3qkL42v0G6Y8HgoF2AtE4OA/fZN1r9nKBC2lerQ2781LZq4NMOAuJzoXOyxUPMAuNdOYw5KgxeLwgIBi4tZw5zOk0TByjRYbgCkZalIiCkIX0DLuvW1QIlCQyOihmyZcMi0nr6bOkrqUL6Sr6j6BugJIPBAbsAyW0zw4BX0G9sNi06vnCuWnQndboCJSkMTppApPcMvsBlNLbILXQ++wlt2edshFD6uIEIpHCIyp3NBgPdQn+F4pIptLkyfdBUqUbgkgfIgH9QTaqKWpt3tFMQzUsV38Dzmo8Cx8993GW1657VYQnkB0Y9F0bOL6jOapkR5nOSai5ZlOVHZf13Zu5+q5EqwyLwniF0gWC/oMrZtgiXrhtkCvcBlQQRKDOErh8d/HOfeQG8qYOtmnSIwB4I7voC/dcOPkoocwdbNfGMwH7JYj/c+RmqNxQG3UUIkH8atHUxVhs5AgdAaA4oM1Q+X6/uYL9CWSoYRCFQPgGhP0B5QvWtg+8N+hQorygEReFHJGX744z+2xqBRiC0BhSXd5NWx2ei2GKcLLyBCrOPonk8aQXCIY0ESjX6zOQ1CpffTVXRV9sKhIMIWL76mkOq6xRw/Nh31ohAOFtAmaHiEjbh8ciEGdPbk6QTEAIAlAwVN3vCGZvsMGF+/E44ScUZSDkKgMnRfkBhPTb5Dij3KSftDaQcDMBM0b5DYcZMyvMjqFeAskg1z85AqgMyWZPj3DVKZgqqwUoyKFGAnFPYzc3DITOreQPlKMx2X0myfI0OSFPUASnDeS6/cxSf5fc29kavQECgFAPG50lyh75XgLItfYTWX0IdDKk/A4vCr6kXKAy2JMwmAowmmiEtoUS2TKF6QWHQJeG3qIVk5KLXDGmJEgK8geoGZddiUj3N97IookAsYTRQXF4Ec5NRFm9uKgUixAlQVjBZC2ZU8yktWMrfqQc7OlUHuHPnGNtXlBylKgUOnk3Aq+eb2sySHMW2n8yg58NAkAx2UzePsD8RnakQoQ30fJ/Y2uzgj09T32w20AVv7oNcsgyMNwRIgsH40sbld/NLGguSC3pRPUggmDUzYyLO/n8D2rJPq5gM2rQafCj4UUyQDA6I2TN41/uKy+/mC8FpJuhF9eCAYMbcwLuK1PdVcJwJelE9RCC5OOt2A6nvrr1rHM2ggGC54l5wVDEPFJ3HMCggnaMQsaP0+CxdalBAEIzkS4oU0FD9oICYYBQBQZH6Jl8ShwjkOQCI1Fd6z9gGXPu96+CAYNlaYWab99n5/cM/Cl8JXXJBvxX0onpwQMyM+a2fz35CW/ZpFfP0NG01+FBI7ylC98D/fEb0fiQD86Rzhcu7ZAptXL4Xv3OYTuFgYzW5tGoHoDQfpfANPK9Np8Cx08fvJjv4YeWk5qN6uMON8Gv1RJf24L8PMfvCqktwKn2e0LbBoOm6Yt+5OdQ9pHNA6h1Nhs3q5xuOlw3nvE8NfsnyjkilA2BMcfiCImUHf311U+nauakZ0hI6Dxj08Njixvu0AmkImVmmXDKDvdfIjqLBTadTg9/UfaICEBnsuYG77Bl0vUO5ZyOWKBBE0oDge8YcRdovYLKXBbJjuz+K0BgdEAQ/N3Fj4PnZFI+nKL7CnyOsfTtJ9p+esjDgf6VOqr9I9oMd3dT9765kMDgUBeIHhMvUwq+Ln/Xo9hC/8Oytd2hxA4++Z+yvYBqaIfWIfD4mBH4anBwGL60Z8hlAeaZA4xEgWPcmCuQw1FyamAlLgNgcqvo5GjuQLcLM8orCDwgL1EeV/wDy2oWH46EvmwAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
);

export const RejectX = () => (
  <svg
    width="10.5"
    height="10.5"
    viewBox="0 0 7 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="3.5" cy="3.5" r="3.5" fill="#DE0A01" />
    <path d="M2 5L4.99955 2" stroke="white" strokeWidth="0.75" />
    <path d="M5 5L2.00045 2" stroke="white" strokeWidth="0.75" />
  </svg>
);

export const ApprovalCheck = () => (
  <svg
    width="13.5"
    height="13.5"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 0.75C2.43 0.75 0.75 2.43 0.75 4.5C0.75 6.57 2.43 8.25 4.5 8.25C6.57 8.25 8.25 6.57 8.25 4.5C8.25 2.43 6.57 0.75 4.5 0.75ZM3.75 6.375L1.875 4.5L2.40375 3.97125L3.75 5.31375L6.59625 2.4675L7.125 3L3.75 6.375Z"
      fill="#00A76D"
    />
  </svg>
);
export const URLField = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_679_11977)">
      <path
        d="M11.5547 4.6665H8.88802V5.99984H11.5547C12.6547 5.99984 13.5547 6.89984 13.5547 7.99984C13.5547 9.09984 12.6547 9.99984 11.5547 9.99984H8.88802V11.3332H11.5547C13.3947 11.3332 14.888 9.83984 14.888 7.99984C14.888 6.15984 13.3947 4.6665 11.5547 4.6665ZM7.55469 9.99984H4.88802C3.78802 9.99984 2.88802 9.09984 2.88802 7.99984C2.88802 6.89984 3.78802 5.99984 4.88802 5.99984H7.55469V4.6665H4.88802C3.04802 4.6665 1.55469 6.15984 1.55469 7.99984C1.55469 9.83984 3.04802 11.3332 4.88802 11.3332H7.55469V9.99984ZM5.55469 7.33317H10.888V8.6665H5.55469V7.33317Z"
        fill="#323232"
      />
    </g>
    <defs>
      <clipPath id="clip0_679_11977">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.221191)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PrimaryAudience = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5878_35207)">
      <path
        d="M2.12484 2.70964H1.0415V11.3763C1.0415 11.9721 1.529 12.4596 2.12484 12.4596H10.7915V11.3763H2.12484V2.70964ZM11.8748 0.542969H4.2915C3.69567 0.542969 3.20817 1.03047 3.20817 1.6263V9.20963C3.20817 9.80547 3.69567 10.293 4.2915 10.293H11.8748C12.4707 10.293 12.9582 9.80547 12.9582 9.20963V1.6263C12.9582 1.03047 12.4707 0.542969 11.8748 0.542969ZM11.8748 9.20963H4.2915V1.6263H11.8748V9.20963Z"
        fill="#5B6670"
      />
    </g>
    <path
      d="M7.84 2.80547C9.04 2.80547 9.8275 3.33797 9.8275 4.46297V4.49297C9.8275 5.62547 9.01 6.12797 7.8625 6.12797H7.1125V8.16797H6.115V2.80547H7.84ZM7.84 5.40797C8.5 5.40797 8.8525 5.08547 8.8525 4.49297V4.46297C8.8525 3.82547 8.4775 3.57797 7.84 3.57797H7.1125V5.40797H7.84Z"
      fill="#5B6670"
    />
    <defs>
      <clipPath id="clip0_5878_35207">
        <rect width="13" height="13" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const Relationship = () => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.21631 5.81958C7.88925 4.69696 5.82625 4.72861 4.54068 5.91453L2.73779 7.57768C2.85109 7.77617 3.00052 7.96238 3.18609 8.1285C3.29037 8.22184 3.40174 8.30498 3.51865 8.37789L5.36484 6.67481C6.19092 5.91276 7.5068 5.87792 8.37766 6.57031L9.21631 5.81958Z"
      fill="#5B6670"
    />
    <path
      d="M2.68849 9.14371L1.81477 9.94971C0.949118 10.7483 0.949118 12.043 1.81477 12.8415C2.68042 13.6401 4.08391 13.6401 4.94956 12.8415L8.49963 9.56662C9.11258 9.00118 9.29151 8.18698 9.03643 7.4763L9.93081 6.6757C10.5975 7.85216 10.3952 9.33857 9.32379 10.3269L5.77372 13.6018C4.4529 14.8202 2.31143 14.8202 0.990613 13.6018C-0.330204 12.3834 -0.330204 10.4079 0.990613 9.18943L1.88444 8.36489C2.01751 8.54572 2.17291 8.71724 2.35065 8.87635C2.45842 8.97282 2.57129 9.06194 2.68849 9.14371Z"
      fill="#5B6670"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.11188 9.11672C3.4327 10.3352 5.57417 10.3352 6.89499 9.11671L10.4451 5.84182C11.7659 4.62338 11.7659 2.64789 10.4451 1.42945C9.12424 0.211015 6.98277 0.211016 5.66195 1.42946L2.11188 4.70436C0.791065 5.92279 0.791065 7.89828 2.11188 9.11672ZM6.48611 2.18973L2.93604 5.46463C2.07039 6.26318 2.07039 7.55789 2.93604 8.35644C3.80169 9.15499 5.20518 9.15499 6.07083 8.35644L9.6209 5.08154C10.4866 4.28299 10.4866 2.98828 9.6209 2.18973C8.75525 1.39118 7.35176 1.39118 6.48611 2.18973Z"
      fill="#5B6670"
    />
  </svg>
);

export const PrimaryAuthor = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4822_34257)">
      <path
        d="M7.99984 3.93464C8.77317 3.93464 9.39984 4.5613 9.39984 5.33464C9.39984 6.10797 8.77317 6.73464 7.99984 6.73464C7.2265 6.73464 6.59984 6.10797 6.59984 5.33464C6.59984 4.5613 7.2265 3.93464 7.99984 3.93464ZM7.99984 9.93463C9.97984 9.93463 12.0665 10.908 12.0665 11.3346V12.068H3.93317V11.3346C3.93317 10.908 6.01984 9.93463 7.99984 9.93463ZM7.99984 2.66797C6.5265 2.66797 5.33317 3.8613 5.33317 5.33464C5.33317 6.80797 6.5265 8.0013 7.99984 8.0013C9.47317 8.0013 10.6665 6.80797 10.6665 5.33464C10.6665 3.8613 9.47317 2.66797 7.99984 2.66797ZM7.99984 8.66797C6.21984 8.66797 2.6665 9.5613 2.6665 11.3346V13.3346H13.3332V11.3346C13.3332 9.5613 9.77984 8.66797 7.99984 8.66797Z"
        fill="#5B6670"
      />
    </g>
    <defs>
      <clipPath id="clip0_4822_34257">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OtherEmployee = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.5" y="1.5" width="11" height="11" rx="0.5" stroke="#5B6670" />
    <g clip-path="url(#clip0_5881_35126)">
      <path
        d="M7.00016 3.44036C7.67683 3.44036 8.22516 3.9887 8.22516 4.66536C8.22516 5.34203 7.67683 5.89037 7.00016 5.89037C6.3235 5.89037 5.77516 5.34203 5.77516 4.66536C5.77516 3.9887 6.3235 3.44036 7.00016 3.44036ZM7.00016 8.69036C8.73266 8.69036 10.5585 9.54203 10.5585 9.91537V10.557H3.44183V9.91537C3.44183 9.54203 5.26766 8.69036 7.00016 8.69036ZM7.00016 2.33203C5.711 2.33203 4.66683 3.3762 4.66683 4.66536C4.66683 5.95453 5.711 6.9987 7.00016 6.9987C8.28933 6.9987 9.3335 5.95453 9.3335 4.66536C9.3335 3.3762 8.28933 2.33203 7.00016 2.33203ZM7.00016 7.58203C5.44266 7.58203 2.3335 8.3637 2.3335 9.91537V11.6654H11.6668V9.91537C11.6668 8.3637 8.55766 7.58203 7.00016 7.58203Z"
        fill="#5B6670"
      />
    </g>
    <defs>
      <clipPath id="clip0_5881_35126">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GenericField = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5878_35111)">
      <rect width="15" height="15" fill="none" />
      <path
        d="M10 0.625H2.5C1.8125 0.625 1.25 1.1875 1.25 1.875V10.625H2.5V1.875H10V0.625ZM9.375 3.125H5C4.3125 3.125 3.75625 3.6875 3.75625 4.375L3.75 13.125C3.75 13.8125 4.30625 14.375 4.99375 14.375H11.875C12.5625 14.375 13.125 13.8125 13.125 13.125V6.875L9.375 3.125ZM5 13.125V4.375H8.75V7.5H11.875V13.125H5Z"
        fill="#5B6670"
      />
    </g>
    <defs>
      <clipPath id="clip0_5878_35111">
        <rect width="15" height="15" fill="none" />
      </clipPath>
    </defs>
  </svg>
);

export const CoAuthor = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.12516 7.88411C4.27266 7.88411 0.583496 8.81036 0.583496 10.6549V12.0404H11.6668V10.6549C11.6668 8.81036 7.97766 7.88411 6.12516 7.88411ZM2.436 10.457C3.101 9.99786 4.70808 9.46745 6.12516 9.46745C7.54225 9.46745 9.14933 9.99786 9.81433 10.457H2.436ZM6.12516 6.4987C7.65308 6.4987 8.896 5.25578 8.896 3.72786C8.896 2.19995 7.65308 0.957031 6.12516 0.957031C4.59725 0.957031 3.35433 2.19995 3.35433 3.72786C3.35433 5.25578 4.59725 6.4987 6.12516 6.4987ZM6.12516 2.54036C6.78225 2.54036 7.31266 3.07078 7.31266 3.72786C7.31266 4.38495 6.78225 4.91536 6.12516 4.91536C5.46808 4.91536 4.93766 4.38495 4.93766 3.72786C4.93766 3.07078 5.46808 2.54036 6.12516 2.54036ZM11.6985 7.93161C12.6168 8.59662 13.2502 9.48328 13.2502 10.6549V12.0404H16.4168V10.6549C16.4168 9.05578 13.646 8.14537 11.6985 7.93161ZM10.8752 6.4987C12.4031 6.4987 13.646 5.25578 13.646 3.72786C13.646 2.19995 12.4031 0.957031 10.8752 0.957031C10.4477 0.957031 10.0518 1.05995 9.68766 1.23411C10.1864 1.9387 10.4793 2.80161 10.4793 3.72786C10.4793 4.65411 10.1864 5.51703 9.68766 6.22161C10.0518 6.39578 10.4477 6.4987 10.8752 6.4987Z"
      fill="#5B6670"
    />
  </svg>
);

export const Calendar = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5878_35146)">
      <path
        d="M10.8335 1.6263H10.2918V0.542969H9.2085V1.6263H3.79183V0.542969H2.7085V1.6263H2.16683C1.571 1.6263 1.0835 2.1138 1.0835 2.70964V11.3763C1.0835 11.9721 1.571 12.4596 2.16683 12.4596H10.8335C11.4293 12.4596 11.9168 11.9721 11.9168 11.3763V2.70964C11.9168 2.1138 11.4293 1.6263 10.8335 1.6263ZM10.8335 11.3763H2.16683V5.41797H10.8335V11.3763ZM10.8335 4.33464H2.16683V2.70964H10.8335V4.33464Z"
        fill="#5B6670"
      />
    </g>
    <defs>
      <clipPath id="clip0_5878_35146">
        <rect width="13" height="13" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AdditionalAudience = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5878_35208)">
      <path
        d="M2.12484 2.70964H1.0415V11.3763C1.0415 11.9721 1.529 12.4596 2.12484 12.4596H10.7915V11.3763H2.12484V2.70964ZM11.8748 0.542969H4.2915C3.69567 0.542969 3.20817 1.03047 3.20817 1.6263V9.20963C3.20817 9.80547 3.69567 10.293 4.2915 10.293H11.8748C12.4707 10.293 12.9582 9.80547 12.9582 9.20963V1.6263C12.9582 1.03047 12.4707 0.542969 11.8748 0.542969ZM11.8748 9.20963H4.2915V1.6263H11.8748V9.20963Z"
        fill="#5B6670"
      />
    </g>
    <path
      d="M8.8 2.80547L10.57 8.16797H9.535L9.1075 6.84047H7.06L6.64 8.16797H5.7025L7.495 2.80547H8.8ZM8.875 6.11297L8.0875 3.62297L7.2925 6.11297H8.875Z"
      fill="#5B6670"
    />
    <defs>
      <clipPath id="clip0_5878_35208">
        <rect width="13" height="13" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const Descending = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4222_31116)">
      <path
        d="M4.5 11L6 9.125H5L5 5.0625L5 2L4 2L4 9.125H3L4.5 11Z"
        fill="#484848"
      />
      <line
        x1="7"
        y1="2.625"
        x2="13"
        y2="2.625"
        stroke="#484848"
        stroke-width="0.75"
      />
      <line
        x1="7"
        y1="4.625"
        x2="12"
        y2="4.625"
        stroke="#484848"
        stroke-width="0.75"
      />
      <line
        x1="7"
        y1="6.625"
        x2="11"
        y2="6.625"
        stroke="#484848"
        stroke-width="0.75"
      />
      <path d="M7 8.5H9.5" stroke="#484848" stroke-width="0.75" />
    </g>
    <defs>
      <clipPath id="clip0_4222_31116">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Ascending = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4222_31072)">
      <path
        d="M4.5 11L6 9.125H5L5 5.0625L5 2L4 2L4 9.125H3L4.5 11Z"
        fill="#484848"
      />
      <line
        y1="-0.375"
        x2="6"
        y2="-0.375"
        transform="matrix(1 0 0 -1 7 8.5)"
        stroke="#484848"
        stroke-width="0.75"
      />
      <line
        y1="-0.375"
        x2="5"
        y2="-0.375"
        transform="matrix(1 0 0 -1 7 6.5)"
        stroke="#484848"
        stroke-width="0.75"
      />
      <line
        y1="-0.375"
        x2="4"
        y2="-0.375"
        transform="matrix(1 0 0 -1 7 4.5)"
        stroke="#484848"
        stroke-width="0.75"
      />
      <path d="M7 3H9.5" stroke="#484848" stroke-width="0.75" />
    </g>
    <defs>
      <clipPath id="clip0_4222_31072">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HelpIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0ZM14.9998 27.8571C7.89903 27.8571 2.14269 22.1007 2.14269 14.9999C2.14269 7.89914 7.89903 2.14281 14.9998 2.14281C22.1006 2.14281 27.857 7.89914 27.857 14.9999C27.857 18.4099 26.5024 21.6801 24.0912 24.0913C21.68 26.5025 18.4098 27.8571 14.9998 27.8571ZM15.5998 5.92491C14.1312 5.75539 12.6601 6.22072 11.5561 7.20394C10.4522 8.18716 9.82035 9.59481 9.81942 11.0731V11.9678H11.9623V11.0731C11.9579 10.2019 12.3272 9.37054 12.9767 8.78974C13.6261 8.20893 14.4933 7.93438 15.3587 8.03563C16.6886 8.19785 17.7575 9.20804 17.9944 10.5267C18.1647 11.4878 17.8593 12.4719 17.1748 13.1678L16.0712 14.2231C14.7097 15.4859 13.9336 17.2572 13.9283 19.1142V19.8213H16.0712V19.1142C16.0751 17.8551 16.5985 16.6534 17.5176 15.7928L18.6641 14.7213C20.0678 13.3166 20.5449 11.233 19.8923 9.35736C19.2397 7.48175 17.5723 6.14428 15.5998 5.9142M15.0001 21.4287C14.1865 21.4287 13.5269 22.0882 13.5269 22.9019C13.5269 23.7155 14.1865 24.3751 15.0001 24.3751C15.8137 24.3751 16.4733 23.7155 16.4733 22.9019C16.4733 22.0882 15.8137 21.4287 15.0001 21.4287Z"
      fill="white"
    />
  </svg>
);

export const FalseCheck = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="13" height="13" rx="1.5" stroke="#B8B8B8" />
    <path d="M4 4.5L10 10.125" stroke="#C3C3C3" strokeWidth="1.5" />
    <path d="M10 4.5L4 10.125" stroke="#C3C3C3" strokeWidth="1.5" />
  </svg>
);

export const TrueCheck = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="14" rx="2" fill="#48c5ec" />
    <path
      d="M2.2002 7.00029L4.77162 9.80029L11.8002 3.80029"
      stroke="white"
      strokeWidth="1.5"
      className="true-check-svg"
    />
  </svg>
);

export const ViewFolder = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.8775 1.5L7.3775 3H14V10.5H2V1.5H5.8775ZM6.5 0H2C1.175 0 0.5075 0.675 0.5075 1.5L0.5 10.5C0.5 11.325 1.175 12 2 12H14C14.825 12 15.5 11.325 15.5 10.5V3C15.5 2.175 14.825 1.5 14 1.5H8L6.5 0Z"
      fill="#323232"
    />
  </svg>
);

export const CancelX = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 1L11 11" stroke="#355578" strokeWidth="1.5" />
    <path d="M11 1L1 11" stroke="#355578" strokeWidth="1.5" />
  </svg>
);

export const GoogleDoc = () => (
  <svg
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7845 4.95161H9.73424C9.43564 4.95167 9.14891 4.83107 8.93559 4.61569C8.72228 4.40032 8.59939 4.10733 8.5933 3.79961V0.599609H1.94166C1.79117 0.599606 1.64217 0.630287 1.50323 0.689886C1.3643 0.749485 1.23818 0.836825 1.13213 0.946875C1.02608 1.05693 0.9422 1.18751 0.885321 1.33112C0.828441 1.47472 0.799685 1.6285 0.800709 1.78361V15.3836C0.7955 15.5414 0.82116 15.6986 0.876161 15.8459C0.931162 15.9933 1.01438 16.1277 1.12085 16.2411C1.22732 16.3546 1.35486 16.4448 1.49588 16.5064C1.6369 16.568 1.7885 16.5997 1.94166 16.5996H11.6591C11.9617 16.5996 12.2519 16.4757 12.4659 16.2552C12.6798 16.0346 12.8 15.7355 12.8 15.4236V5.02361L12.7845 4.95161ZM8.74075 14.1996H2.40005V12.5996H8.74075V14.1996ZM11.2 10.9996H2.40005V9.39961H11.2V10.9996ZM11.2 7.79961H2.40005V6.19961H11.2V7.79961Z"
      fill="#0052D6"
    />
  </svg>
);

export const GIcon = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.272 14.198C3.06 14.198 0.72 11.462 0.72 7.646V7.502C0.72 3.632 3.474 0.932 7.272 0.932C10.134 0.932 12.69 2.246 12.996 5.432H10.098C9.846 3.92 8.856 3.236 7.308 3.236C5.076 3.236 3.762 4.91 3.762 7.538V7.682C3.762 10.166 4.824 11.948 7.344 11.948C9.504 11.948 10.386 10.706 10.44 9.23H7.542V7.106H13.32V8.474C13.32 11.912 11.124 14.198 7.272 14.198Z"
      fill="#0052D6"
    />
  </svg>
);

export const DocSearch = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.66993 7.06229C10.2927 7.0618 10.9042 7.23081 11.4407 7.55167C11.9772 7.87254 12.419 8.33352 12.72 8.88655C13.0211 9.43957 13.1704 10.0644 13.1523 10.6959C13.1342 11.3273 12.9495 11.9423 12.6173 12.4767L15 14.9093L13.9247 16L11.5111 13.591C11.0537 13.8799 10.5364 14.0571 10 14.1088C9.46361 14.1604 8.9227 14.0851 8.41988 13.8886C7.91707 13.6922 7.46607 13.38 7.10239 12.9768C6.73872 12.5735 6.4723 12.0901 6.32411 11.5646C6.17592 11.0391 6.15001 10.4859 6.24841 9.94855C6.34681 9.41119 6.56684 8.90433 6.89118 8.46789C7.21552 8.03144 7.63531 7.67732 8.1175 7.43341C8.59969 7.1895 9.13111 7.06246 9.66993 7.06229ZM9.66993 8.63168C9.28743 8.63168 8.91351 8.74674 8.59547 8.9623C8.27743 9.17786 8.02954 9.48424 7.88316 9.8427C7.73678 10.2012 7.69848 10.5956 7.77311 10.9761C7.84773 11.3567 8.03193 11.7062 8.3024 11.9806C8.57287 12.2549 8.91747 12.4418 9.29263 12.5175C9.66779 12.5932 10.0566 12.5543 10.41 12.4058C10.7634 12.2574 11.0655 12.0059 11.278 11.6833C11.4905 11.3607 11.6039 10.9814 11.6039 10.5934C11.6039 10.0731 11.4002 9.57416 11.0375 9.20626C10.6748 8.83837 10.1829 8.63168 9.66993 8.63168ZM3.09438 9.41638V10.9858H4.64157C4.74453 12.1627 5.23819 13.2693 6.04177 14.1246H1.54719C1.13685 14.1246 0.743315 13.9592 0.453161 13.6649C0.163007 13.3706 0 12.9714 0 12.5552V1.5694C0 1.15317 0.163007 0.753985 0.453161 0.459666C0.743315 0.165347 1.13685 0 1.54719 0H12.3775C12.7879 0 13.1814 0.165347 13.4715 0.459666C13.7617 0.753985 13.9247 1.15317 13.9247 1.5694V7.84698C13.5705 7.27868 13.109 6.78702 12.5668 6.40028C12.0246 6.01355 11.4124 5.73937 10.7653 5.59351C10.1182 5.44766 9.44915 5.43301 8.7965 5.55041C8.14384 5.66781 7.52051 5.91494 6.96235 6.27759H3.09438V7.84698H5.41516C5.12329 8.33374 4.90674 8.86303 4.77308 9.41638H3.09438ZM10.8303 4.70819V3.13879H3.09438V4.70819H10.8303Z"
      fill="#0052D6"
    />
  </svg>
);

export const Kanban = () => (
  <svg
    className="cpp-ui-icon cpp-icon-kanban"
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.75 0H1.25C0.8375 0 0.5 0.3375 0.5 0.75V11.25C0.5 11.6625 0.8375 12 1.25 12H14.75C15.1625 12 15.5 11.6625 15.5 11.25V0.75C15.5 0.3375 15.1625 0 14.75 0ZM5 10.5H2V1.5H5V10.5ZM9.5 10.5H6.5V1.5H9.5V10.5ZM14 10.5H11V1.5H14V10.5Z"
      fill="#6F7878"
    />
  </svg>
);

export const Tabular = () => (
  <svg
    className="cpp-ui-icon cpp-icon-tabular"
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.625 0.375C1.07272 0.375 0.625 0.822715 0.625 1.375V11.625C0.625 12.1773 1.07272 12.625 1.625 12.625H14.5C15.0523 12.625 15.5 12.1773 15.5 11.625V1.375C15.5 0.822716 15.0523 0.375 14.5 0.375H1.625ZM3.25 2.125C3.73325 2.125 4.125 2.51675 4.125 3C4.125 3.48325 3.73325 3.875 3.25 3.875C2.76675 3.875 2.375 3.48325 2.375 3C2.375 2.51675 2.76675 2.125 3.25 2.125ZM3.25 7.375C2.76675 7.375 2.375 6.98325 2.375 6.5C2.375 6.01675 2.76675 5.625 3.25 5.625C3.73325 5.625 4.125 6.01675 4.125 6.5C4.125 6.98325 3.73325 7.375 3.25 7.375ZM2.375 10C2.375 9.51675 2.76675 9.125 3.25 9.125C3.73325 9.125 4.125 9.51675 4.125 10C4.125 10.4832 3.73325 10.875 3.25 10.875C2.76675 10.875 2.375 10.4832 2.375 10ZM13.75 10C13.75 10.4832 13.3582 10.875 12.875 10.875H6.75C6.26675 10.875 5.875 10.4832 5.875 10C5.875 9.51675 6.26675 9.125 6.75 9.125H12.875C13.3582 9.125 13.75 9.51675 13.75 10ZM13.75 6.5C13.75 6.98325 13.3582 7.375 12.875 7.375H6.75C6.26675 7.375 5.875 6.98325 5.875 6.5C5.875 6.01675 6.26675 5.625 6.75 5.625H12.875C13.3582 5.625 13.75 6.01675 13.75 6.5ZM13.75 3C13.75 3.48325 13.3582 3.875 12.875 3.875H6.75C6.26675 3.875 5.875 3.48325 5.875 3C5.875 2.51675 6.26675 2.125 6.75 2.125H12.875C13.3582 2.125 13.75 2.51675 13.75 3Z"
      fill="#6F7878"
    />
  </svg>
);

export const Workspace = ({
  isHome,
  title
}: {
  isHome?: boolean;
  title?: string;
}) => (
  <span className="workspace-icon" title={title}>
    <svg
      className="cpp-ui-icon cpp-icon-workspace"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M17.5 6.06667V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V13.9333C17.9917 13.6417 18.3333 13.1167 18.3333 12.5V7.5C18.3333 6.88333 17.9917 6.35833 17.5 6.06667ZM16.6667 7.5V12.5H10.8333V7.5H16.6667ZM4.16667 15.8333V4.16667H15.8333V5.83333H10.8333C9.91667 5.83333 9.16667 6.58333 9.16667 7.5V12.5C9.16667 13.4167 9.91667 14.1667 10.8333 14.1667H15.8333V15.8333H4.16667Z"
          fill="black"
        />
        <path
          d="M13.3333 11.25C14.0237 11.25 14.5833 10.6904 14.5833 10C14.5833 9.30964 14.0237 8.75 13.3333 8.75C12.643 8.75 12.0833 9.30964 12.0833 10C12.0833 10.6904 12.643 11.25 13.3333 11.25Z"
          fill="black"
        />
      </g>
    </svg>
    {isHome && (
      <svg
        className="cpp-ui-icon cpp-icon-home"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="6" cy="6" r="6" fill="#00A76D" />
        <g clipPath="url(#clip0_5475_34897)">
          <path
            d="M5.2 9.19844V6.79844H6.8V9.19844H8.8V5.99844H10L6 2.39844L2 5.99844H3.2V9.19844H5.2Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_5475_34897">
            <rect
              width="9.6"
              height="9.6"
              fill="white"
              transform="translate(1.19995 1.19922)"
            />
          </clipPath>
        </defs>
      </svg>
    )}
  </span>
);

export const ThreeDots = () => (
  <svg
    className="cpp-ui-icon cpp-icon-threedots"
    width="3"
    height="13"
    viewBox="0 0 3 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.5" cy="1.5" r="1.5" fill="#003180" />
    <circle cx="1.5" cy="6.5" r="1.5" fill="#003180" />
    <circle cx="1.5" cy="11.5" r="1.5" fill="#003180" />
  </svg>
);

export const SixDots = () => (
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="six-dots"
    style={{ cursor: 'move' }}
  >
    <circle cx="1" cy="1" r="1" fill="#ACACAC" />
    <circle cx="5" cy="1" r="1" fill="#ACACAC" />
    <circle cx="5" cy="5" r="1" fill="#ACACAC" />
    <circle cx="1" cy="5" r="1" fill="#ACACAC" />
    <circle cx="5" cy="9" r="1" fill="#ACACAC" />
    <circle cx="1" cy="9" r="1" fill="#ACACAC" />
  </svg>
);

export const DataSource = () => (
  <svg
    className="cpp-ui-icon cpp-icon-threedots"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.11 0 16 0ZM16 16H2V4H16V16ZM14 9H4V7H14V9ZM10 13H4V11H10V13Z"
      fill="#323232"
    />
  </svg>
);

export const Form = () => (
  <svg
    className="cpp-ui-icon cpp-icon-form"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.11 0 16 0ZM16 16H2V4H16V16ZM14 9H4V7H14V9ZM10 13H4V11H10V13Z"
      fill="#323232"
    />
  </svg>
);

export const Configure = () => (
  <svg
    className="cpp-ui-icon cpp-icon-configure"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.91671 0.996729C2.91671 0.659612 2.65421 0.383789 2.33337 0.383789C2.01254 0.383789 1.75004 0.659612 1.75004 0.996729V3.44849H0.583374V9.57789C0.583374 10.3747 1.07337 11.0489 1.75004 11.3064V13.8685H2.91671V11.3064C3.59337 11.0489 4.08337 10.3747 4.08337 9.57789V3.44849H2.91671V0.996729ZM2.33337 10.1908C2.01254 10.1908 1.75004 9.91501 1.75004 9.57789V8.35201H2.91671V9.57789C2.91671 9.91501 2.65421 10.1908 2.33337 10.1908ZM1.75004 7.12613V4.67437H2.91671V7.12613H1.75004ZM7.58337 0.996729C7.58337 0.659612 7.32087 0.383789 7.00004 0.383789C6.67921 0.383789 6.41671 0.659612 6.41671 0.996729V3.44849H5.25004V9.57789C5.25004 10.3747 5.74004 11.0489 6.41671 11.3064V13.8685H7.58337V11.3064C8.26004 11.0489 8.75004 10.3747 8.75004 9.57789V3.44849H7.58337V0.996729ZM7.00004 10.1908C6.67921 10.1908 6.41671 9.91501 6.41671 9.57789V8.35201H7.58337V9.57789C7.58337 9.91501 7.32087 10.1908 7.00004 10.1908ZM6.41671 7.12613V4.67437H7.58337V7.12613H6.41671ZM12.25 3.44849V0.996729C12.25 0.659612 11.9875 0.383789 11.6667 0.383789C11.3459 0.383789 11.0834 0.659612 11.0834 0.996729V3.44849H9.91671V9.57789C9.91671 10.3747 10.4067 11.0489 11.0834 11.3064V13.8685H12.25V11.3064C12.9267 11.0489 13.4167 10.3747 13.4167 9.57789V3.44849H12.25ZM11.6667 10.1908C11.3459 10.1908 11.0834 9.91501 11.0834 9.57789V8.35201H12.25V9.57789C12.25 9.91501 11.9875 10.1908 11.6667 10.1908ZM11.0834 7.12613V4.67437H12.25V7.12613H11.0834Z"
      fill="#717171"
    />
  </svg>
);

export const Manage = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7198_74694)">
      <path
        d="M11.0833 8.74996V9.91663H2.91667V8.74996H11.0833ZM12.25 2.91663H1.75V4.08329H12.25V2.91663ZM12.25 5.24996H1.75V6.41663H12.25V5.24996ZM12.25 7.58329H1.75V11.0833H12.25V7.58329Z"
        fill="#757575"
      />
    </g>
    <defs>
      <clipPath id="clip0_7198_74694">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Display = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_982_25853)">
      <path
        d="M12.5 11.25C13.1875 11.25 13.7437 10.6875 13.7437 10L13.75 3.75C13.75 3.0625 13.1875 2.5 12.5 2.5H2.5C1.8125 2.5 1.25 3.0625 1.25 3.75V10C1.25 10.6875 1.8125 11.25 2.5 11.25H0V12.5H15V11.25H12.5ZM2.5 3.75H12.5V10H2.5V3.75Z"
        fill="#717171"
      />
    </g>
  </svg>
);

export const Sort = () => (
  <svg
    className="cpp-ui-icon cpp-icon-sort"
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.66667 9.32937H7.33333V7.92837H4.66667V9.32937ZM0 0.92334V2.32435H12V0.92334H0ZM2 5.82686H10V4.42585H2V5.82686Z"
      fill="#717171"
    />
  </svg>
);

export const Setup = () => (
  <svg
    className="cpp-ui-icon cpp-icon-setup"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0833 3.8355V12.4167H2.91667V3.8355H11.0833ZM11.0833 2.60962H2.91667C2.275 2.60962 1.75 3.16127 1.75 3.8355V12.4167C1.75 13.0909 2.275 13.6425 2.91667 13.6425H11.0833C11.725 13.6425 12.25 13.0909 12.25 12.4167V3.8355C12.25 3.16127 11.725 2.60962 11.0833 2.60962Z"
      fill="#757575"
    />
    <path
      d="M8.16659 11.1907H4.08325V9.9648H8.16659V11.1907ZM9.91659 8.73892H4.08325V7.51304H9.91659V8.73892ZM9.91659 6.28716H4.08325V5.06128H9.91659V6.28716Z"
      fill="#757575"
    />
  </svg>
);

export const Person = () => (
  <svg
    className="cpp-ui-icon cpp-icon-person"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 1.425C6.87 1.425 7.575 2.13 7.575 3C7.575 3.87 6.87 4.575 6 4.575C5.13 4.575 4.425 3.87 4.425 3C4.425 2.13 5.13 1.425 6 1.425ZM6 8.175C8.2275 8.175 10.575 9.27 10.575 9.75V10.575H1.425V9.75C1.425 9.27 3.7725 8.175 6 8.175ZM6 0C4.3425 0 3 1.3425 3 3C3 4.6575 4.3425 6 6 6C7.6575 6 9 4.6575 9 3C9 1.3425 7.6575 0 6 0ZM6 6.75C3.9975 6.75 0 7.755 0 9.75V12H12V9.75C12 7.755 8.0025 6.75 6 6.75Z"
      fill="#5B6670"
    />
  </svg>
);

export const Ref = () => (
  <svg
    className="cpp-ui-icon cpp-icon-ref"
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.66671 0.666626H1.66671C0.933374 0.666626 0.333374 1.26663 0.333374 1.99996V11.3333H1.66671V1.99996H9.66671V0.666626ZM9.00004 3.33329H4.33337C3.60004 3.33329 3.00671 3.93329 3.00671 4.66663L3.00004 14C3.00004 14.7333 3.59337 15.3333 4.32671 15.3333H11.6667C12.4 15.3333 13 14.7333 13 14V7.33329L9.00004 3.33329ZM4.33337 14V4.66663H8.33337V7.99996H11.6667V14H4.33337Z"
      fill="#5B6670"
    />
  </svg>
);

export const Add = ({ inverted }: { inverted?: boolean }) => (
  <svg
    className="cpp-ui-icon cpp-icon-add"
    width={!inverted ? '16' : '18'}
    height={!inverted ? '16' : '17'}
    viewBox={!inverted ? '0 0 16 16' : '0 0 18 17'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {!inverted ? (
      <path
        d="M8.75 4.25H7.25V7.25H4.25V8.75H7.25V11.75H8.75V8.75H11.75V7.25H8.75V4.25ZM8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.5ZM8 14C4.6925 14 2 11.3075 2 8C2 4.6925 4.6925 2 8 2C11.3075 2 14 4.6925 14 8C14 11.3075 11.3075 14 8 14Z"
        fill="#002856"
      />
    ) : (
      <path
        d="M9.00033 0.166626C4.40033 0.166626 0.666992 3.89996 0.666992 8.49996C0.666992 13.1 4.40033 16.8333 9.00033 16.8333C13.6003 16.8333 17.3337 13.1 17.3337 8.49996C17.3337 3.89996 13.6003 0.166626 9.00033 0.166626ZM13.167 9.33329H9.83366V12.6666H8.16699V9.33329H4.83366V7.66663H8.16699V4.33329H9.83366V7.66663H13.167V9.33329Z"
        fill="white"
      />
    )}
  </svg>
);

export const FieldIcon = {
  Text: () => (
    <svg
      className="cpp-ui-icon cpp-icon-field-text"
      width="15"
      height="10"
      viewBox="0 0 15 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.91721 9H0.519487L3.66011 0.272727H5.18142L8.32204 9H6.92432L4.45699 1.85795H4.38881L1.91721 9ZM2.15159 5.58239H6.68568V6.69034H2.15159V5.58239ZM11.3849 9.14489C10.9701 9.14489 10.5951 9.06818 10.2599 8.91477C9.92467 8.75852 9.65905 8.53267 9.46302 8.23722C9.26984 7.94176 9.17325 7.57955 9.17325 7.15057C9.17325 6.78125 9.24427 6.47727 9.38632 6.23864C9.52836 6 9.72013 5.81108 9.9616 5.67188C10.2031 5.53267 10.473 5.42756 10.7713 5.35653C11.0696 5.28551 11.3735 5.23153 11.6832 5.1946C12.0752 5.14915 12.3934 5.11222 12.6377 5.08381C12.8821 5.05256 13.0596 5.00284 13.1704 4.93466C13.2812 4.86648 13.3366 4.75568 13.3366 4.60227V4.57244C13.3366 4.20028 13.2315 3.91193 13.0213 3.70739C12.8139 3.50284 12.5042 3.40057 12.0923 3.40057C11.6633 3.40057 11.3252 3.49574 11.0781 3.68608C10.8338 3.87358 10.6647 4.08239 10.571 4.3125L9.37354 4.03977C9.51558 3.64205 9.72297 3.32102 9.99569 3.0767C10.2713 2.82955 10.588 2.65057 10.946 2.53977C11.3039 2.42614 11.6804 2.36932 12.0752 2.36932C12.3366 2.36932 12.6136 2.40057 12.9062 2.46307C13.2017 2.52273 13.4772 2.63352 13.7329 2.79545C13.9914 2.95739 14.2031 3.18892 14.3679 3.49006C14.5326 3.78835 14.615 4.17614 14.615 4.65341V9H13.3707V8.10511H13.3196C13.2372 8.26989 13.1136 8.43182 12.9488 8.59091C12.784 8.75 12.5724 8.8821 12.3139 8.98722C12.0554 9.09233 11.7457 9.14489 11.3849 9.14489ZM11.6619 8.12216C12.0142 8.12216 12.3153 8.05256 12.5653 7.91335C12.8181 7.77415 13.0099 7.59233 13.1406 7.3679C13.2741 7.14062 13.3409 6.89773 13.3409 6.6392V5.79545C13.2954 5.84091 13.2073 5.88352 13.0767 5.9233C12.9488 5.96023 12.8025 5.9929 12.6377 6.02131C12.473 6.04687 12.3125 6.07102 12.1562 6.09375C12 6.11364 11.8693 6.13068 11.7642 6.14489C11.517 6.17614 11.2911 6.22869 11.0866 6.30256C10.8849 6.37642 10.723 6.48295 10.6008 6.62216C10.4815 6.75852 10.4218 6.94034 10.4218 7.16761C10.4218 7.48295 10.5383 7.72159 10.7713 7.88352C11.0042 8.04261 11.3011 8.12216 11.6619 8.12216Z"
        fill="black"
      />
    </svg>
  ),
  Numeric: () => (
    <svg
      className="cpp-ui-icon cpp-icon-field-numeric"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.22103 3.33317H0.887695V13.9998C0.887695 14.7332 1.4877 15.3332 2.22103 15.3332H12.8877V13.9998H2.22103V3.33317ZM14.221 0.666504H4.8877C4.15436 0.666504 3.55436 1.2665 3.55436 1.99984V11.3332C3.55436 12.0665 4.15436 12.6665 4.8877 12.6665H14.221C14.9544 12.6665 15.5544 12.0665 15.5544 11.3332V1.99984C15.5544 1.2665 14.9544 0.666504 14.221 0.666504ZM14.221 11.3332H4.8877V1.99984H14.221V11.3332ZM11.5544 8.6665H8.88769V7.33317H10.221C10.9544 7.33317 11.5544 6.73984 11.5544 5.99984V4.6665C11.5544 3.9265 10.9544 3.33317 10.221 3.33317H7.55436V4.6665H10.221V5.99984H8.88769C8.15436 5.99984 7.55436 6.59317 7.55436 7.33317V9.99984H11.5544V8.6665Z"
        fill="#323232"
      />
    </svg>
  ),
  Date: () => (
    <svg
      className="cpp-ui-icon cpp-icon-field-date"
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8877 1.75016H10.3044V0.583496H9.1377V1.75016H3.30436V0.583496H2.1377V1.75016H1.55436C0.912695 1.75016 0.387695 2.27516 0.387695 2.91683V12.2502C0.387695 12.8918 0.912695 13.4168 1.55436 13.4168H10.8877C11.5294 13.4168 12.0544 12.8918 12.0544 12.2502V2.91683C12.0544 2.27516 11.5294 1.75016 10.8877 1.75016ZM10.8877 12.2502H1.55436V5.8335H10.8877V12.2502ZM10.8877 4.66683H1.55436V2.91683H10.8877V4.66683Z"
        fill="#323232"
      />
    </svg>
  ),
  Boolean: () => (
    <svg
      className="cpp-ui-icon cpp-icon-field-boolean"
      width="16"
      height="8"
      viewBox="0 0 16 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5544 0H4.8877C2.68103 0 0.887695 1.79333 0.887695 4C0.887695 6.20667 2.68103 8 4.8877 8H11.5544C13.761 8 15.5544 6.20667 15.5544 4C15.5544 1.79333 13.761 0 11.5544 0ZM11.5544 6.66667H4.8877C3.41436 6.66667 2.22103 5.47333 2.22103 4C2.22103 2.52667 3.41436 1.33333 4.8877 1.33333H11.5544C13.0277 1.33333 14.221 2.52667 14.221 4C14.221 5.47333 13.0277 6.66667 11.5544 6.66667ZM11.5544 2C10.4477 2 9.55436 2.89333 9.55436 4C9.55436 5.10667 10.4477 6 11.5544 6C12.661 6 13.5544 5.10667 13.5544 4C13.5544 2.89333 12.661 2 11.5544 2Z"
        fill="#323232"
      />
    </svg>
  ),
  Reference: () => (
    <svg
      className="cpp-ui-icon cpp-icon-field-reference"
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5547 0.666504H7.88802V1.99984H10.5547C11.6547 1.99984 12.5547 2.89984 12.5547 3.99984C12.5547 5.09984 11.6547 5.99984 10.5547 5.99984H7.88802V7.33317H10.5547C12.3947 7.33317 13.888 5.83984 13.888 3.99984C13.888 2.15984 12.3947 0.666504 10.5547 0.666504ZM6.55469 5.99984H3.88802C2.78802 5.99984 1.88802 5.09984 1.88802 3.99984C1.88802 2.89984 2.78802 1.99984 3.88802 1.99984H6.55469V0.666504H3.88802C2.04802 0.666504 0.554688 2.15984 0.554688 3.99984C0.554688 5.83984 2.04802 7.33317 3.88802 7.33317H6.55469V5.99984ZM4.55469 3.33317H9.88802V4.6665H4.55469V3.33317Z"
        fill="#323232"
      />
    </svg>
  ),
  MultiSelect: () => (
    <svg
      className="cpp-ui-icon cpp-icon-field-multiselect"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5547 1.66683V9.66683H4.55469V1.66683H12.5547ZM12.5547 0.333496H4.55469C3.82135 0.333496 3.22135 0.933496 3.22135 1.66683V9.66683C3.22135 10.4002 3.82135 11.0002 4.55469 11.0002H12.5547C13.288 11.0002 13.888 10.4002 13.888 9.66683V1.66683C13.888 0.933496 13.288 0.333496 12.5547 0.333496ZM7.53469 8.3335L5.22135 6.00016L6.15469 5.06016L7.53469 6.44683L10.9547 3.00016L11.888 3.94016L7.53469 8.3335ZM1.88802 3.00016H0.554688V12.3335C0.554688 13.0668 1.15469 13.6668 1.88802 13.6668H11.2214V12.3335H1.88802V3.00016Z"
        fill="#323232"
      />
    </svg>
  )
};

export const Copy = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
        fill="#0052D6"
      />
    </g>
  </svg>
);

export const Trash = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M8.28653 4.13797L7.3472 4.10352L7.14355 9.66486L8.08288 9.69917L8.28653 4.13797Z"
        fill="#355578"
      />
      <path
        d="M6.46972 4.12012H5.52979V9.68149H6.46972V4.12012Z"
        fill="#355578"
      />
      <path
        d="M4.85587 9.6639L4.65222 4.10254L3.71289 4.13702L3.91656 9.69835L4.85587 9.6639Z"
        fill="#355578"
      />
      <path
        d="M0.407227 1.80176V2.7417H1.38666L2.16366 11.5714C2.18496 11.8141 2.38816 12.0002 2.63175 12.0002H9.35222C9.59583 12.0002 9.79917 11.8139 9.82031 11.5713L10.5973 2.7417H11.5926V1.80176H0.407227ZM8.92174 11.0603H3.06211L2.3302 2.7417H9.65381L8.92174 11.0603Z"
        fill="#355578"
      />
      <path
        d="M7.53493 0H4.46443C4.03253 0 3.68115 0.351375 3.68115 0.783281V2.27154H4.62109V0.939937H7.37827V2.27154H8.31821V0.783281C8.31821 0.351375 7.96683 0 7.53493 0Z"
        fill="#355578"
      />
      <path
        d="M7.53493 0H4.46443C4.03253 0 3.68115 0.351375 3.68115 0.783281V2.27154H4.62109V0.939937H7.37827V2.27154H8.31821V0.783281C8.31821 0.351375 7.96683 0 7.53493 0Z"
        stroke="#355578"
      />
    </g>
  </svg>
);

export const RoundedClose = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4" cy="4" r="4" fill="#C3C3C3" />
    <path d="M2.33301 2.66602L5.66634 5.66602" stroke="white" />
    <path d="M5.6665 2.66602L2.33317 5.66602" stroke="white" />
  </svg>
);

export const DownArrow = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="9"
    height="7"
    viewBox="0 0 9 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0.777832L4.5 5.22228L1 0.777832"
      stroke="#0042AB"
      strokeWidth="1.5"
    />
  </svg>
);

export const LargeRoundedClose = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="white" />
    <path
      d="M6 6L10 10"
      stroke="#AEAEAE"
      strokeWidth="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 6L6 10"
      stroke="#AEAEAE"
      strokeWidth="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const UserGroup = () => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    className="cpp-ui-icon cpp-icon-usergroup"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M-0.00146484 13.0896V11.237C-0.00146484 10.8075 0.109382 10.4243 0.331077 10.0872C0.552757 9.75015 0.848813 9.4879 1.21924 9.30047C2.0112 8.91311 2.80755 8.61446 3.60828 8.40453C4.40903 8.1946 5.28911 8.08964 6.24851 8.08964C7.20792 8.08964 8.08799 8.1946 8.88872 8.40453C9.68947 8.61446 10.4858 8.91311 11.2778 9.30047C11.6482 9.4879 11.9443 9.75015 12.166 10.0872C12.3876 10.4243 12.4985 10.8075 12.4985 11.237V13.0896H-0.00146484ZM14.1651 13.0896V11.1345C14.1651 10.5875 14.0312 10.0662 13.7633 9.57053C13.4955 9.07491 13.1155 8.64965 12.6235 8.29476C13.1823 8.37809 13.7127 8.5071 14.2148 8.68178C14.717 8.85646 15.1961 9.06292 15.6523 9.30116C16.0829 9.53085 16.4154 9.80157 16.6499 10.1133C16.8844 10.4251 17.0017 10.7655 17.0017 11.1345V13.0896H14.1651ZM6.24851 6.74343C5.44645 6.74343 4.75982 6.45784 4.18864 5.88668C3.61746 5.3155 3.33187 4.62887 3.33187 3.8268C3.33187 3.02472 3.61746 2.33809 4.18864 1.76693C4.75982 1.19575 5.44645 0.910156 6.24851 0.910156C7.05058 0.910156 7.73721 1.19575 8.30839 1.76693C8.87956 2.33809 9.16514 3.02472 9.16514 3.8268C9.16514 4.62887 8.87956 5.3155 8.30839 5.88668C7.73721 6.45784 7.05058 6.74343 6.24851 6.74343ZM13.444 3.8268C13.444 4.62887 13.1584 5.3155 12.5872 5.88668C12.016 6.45784 11.3294 6.74343 10.5273 6.74343C10.4333 6.74343 10.3136 6.73275 10.1683 6.71139C10.0231 6.69003 9.9034 6.66653 9.80939 6.64089C10.138 6.24579 10.3906 5.80748 10.5671 5.32595C10.7436 4.84442 10.8318 4.34437 10.8318 3.8258C10.8318 3.30725 10.7418 2.80919 10.5618 2.33162C10.3818 1.85406 10.131 1.41443 9.80939 1.01272C9.92904 0.969983 10.0487 0.942206 10.1683 0.929386C10.288 0.916567 10.4077 0.910156 10.5273 0.910156C11.3294 0.910156 12.016 1.19575 12.5872 1.76693C13.1584 2.33809 13.444 3.02472 13.444 3.8268ZM1.24851 11.8396H11.2485V11.237C11.2485 11.0629 11.205 10.908 11.1179 10.7723C11.0308 10.6366 10.8927 10.518 10.7036 10.4165C10.0177 10.0629 9.31154 9.79499 8.58506 9.61282C7.85856 9.43067 7.07971 9.33959 6.24851 9.33959C5.41732 9.33959 4.63847 9.43067 3.91197 9.61282C3.18549 9.79499 2.47929 10.0629 1.79339 10.4165C1.60429 10.518 1.4662 10.6366 1.37912 10.7723C1.29205 10.908 1.24851 11.0629 1.24851 11.237V11.8396ZM6.24851 5.49347C6.70685 5.49347 7.09921 5.33028 7.4256 5.00389C7.75199 4.6775 7.91518 4.28514 7.91518 3.8268C7.91518 3.36847 7.75199 2.97611 7.4256 2.64972C7.09921 2.32333 6.70685 2.16014 6.24851 2.16014C5.79018 2.16014 5.39782 2.32333 5.07143 2.64972C4.74504 2.97611 4.58185 3.36847 4.58185 3.8268C4.58185 4.28514 4.74504 4.6775 5.07143 5.00389C5.39782 5.33028 5.79018 5.49347 6.24851 5.49347Z"
      fill="#0052D6"
    />
  </svg>
);

export const Check = () => (
  <svg
    width="19"
    height="15"
    viewBox="0 0 19 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5224 3.58659L14.7123 2.89819L8.09921 10.8991L4.15671 7.54284L3.47852 8.36248L8.22852 12.4098L15.5224 3.58659Z"
      fill="#002856"
    />
  </svg>
);

export const BlueCheck = () => (
  <svg
    width="13"
    height="11"
    viewBox="0 0 13 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.5 6.5L4.5 10L8.25 5.5L12 1" stroke="#0052D6" />
  </svg>
);

export const Resolved = () => (
  <svg
    width="46"
    height="14"
    viewBox="0 0 46 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2401_22940)">
      <rect x="0.5" y="0.5" width="45" height="13" stroke="#ADB89B" />
      <path
        d="M2.8252 2.89062H5.17871C5.71257 2.89062 6.16341 2.97201 6.53125 3.13477C6.90234 3.29753 7.18392 3.53841 7.37598 3.85742C7.57129 4.17318 7.66895 4.56217 7.66895 5.02441C7.66895 5.34993 7.60221 5.64779 7.46875 5.91797C7.33854 6.1849 7.14974 6.41276 6.90234 6.60156C6.6582 6.78711 6.36523 6.92546 6.02344 7.0166L5.75977 7.11914H3.54785L3.53809 6.35254H5.20801C5.54655 6.35254 5.82812 6.29395 6.05273 6.17676C6.27734 6.05632 6.44661 5.89518 6.56055 5.69336C6.67448 5.49154 6.73145 5.26855 6.73145 5.02441C6.73145 4.75098 6.67773 4.51172 6.57031 4.30664C6.46289 4.10156 6.29362 3.94368 6.0625 3.83301C5.83464 3.71908 5.54004 3.66211 5.17871 3.66211H3.76758V10H2.8252V2.89062ZM6.98047 10L5.25195 6.77734L6.2334 6.77246L7.98633 9.94141V10H6.98047ZM11.043 10.0977C10.6751 10.0977 10.3415 10.0358 10.042 9.91211C9.74577 9.78516 9.49023 9.60775 9.27539 9.37988C9.0638 9.15202 8.90104 8.88184 8.78711 8.56934C8.67318 8.25684 8.61621 7.91504 8.61621 7.54395V7.33887C8.61621 6.90918 8.67969 6.52669 8.80664 6.19141C8.93359 5.85286 9.10612 5.56641 9.32422 5.33203C9.54232 5.09766 9.78971 4.92025 10.0664 4.7998C10.3431 4.67936 10.6296 4.61914 10.9258 4.61914C11.3034 4.61914 11.6289 4.68424 11.9023 4.81445C12.179 4.94466 12.4053 5.12695 12.5811 5.36133C12.7568 5.59245 12.887 5.86589 12.9717 6.18164C13.0563 6.49414 13.0986 6.83594 13.0986 7.20703V7.6123H9.15332V6.875H12.1953V6.80664C12.1823 6.57227 12.1335 6.3444 12.0488 6.12305C11.9674 5.90169 11.8372 5.7194 11.6582 5.57617C11.4792 5.43294 11.235 5.36133 10.9258 5.36133C10.7207 5.36133 10.5319 5.40527 10.3594 5.49316C10.1868 5.5778 10.0387 5.70475 9.91504 5.87402C9.79134 6.04329 9.69531 6.25 9.62695 6.49414C9.55859 6.73828 9.52441 7.01986 9.52441 7.33887V7.54395C9.52441 7.7946 9.55859 8.0306 9.62695 8.25195C9.69857 8.47005 9.80111 8.66211 9.93457 8.82812C10.0713 8.99414 10.2357 9.12435 10.4277 9.21875C10.623 9.31315 10.8444 9.36035 11.0918 9.36035C11.4108 9.36035 11.681 9.29525 11.9023 9.16504C12.1237 9.03483 12.3174 8.86068 12.4834 8.64258L13.0303 9.07715C12.9163 9.24967 12.7715 9.41406 12.5957 9.57031C12.4199 9.72656 12.2035 9.85352 11.9463 9.95117C11.6924 10.0488 11.3913 10.0977 11.043 10.0977ZM17.2295 8.59863C17.2295 8.46842 17.2002 8.34798 17.1416 8.2373C17.0863 8.12337 16.9707 8.02083 16.7949 7.92969C16.6224 7.83529 16.362 7.75391 16.0137 7.68555C15.7207 7.6237 15.4554 7.55046 15.2178 7.46582C14.9834 7.38118 14.7832 7.27865 14.6172 7.1582C14.4544 7.03776 14.3291 6.89616 14.2412 6.7334C14.1533 6.57064 14.1094 6.38021 14.1094 6.16211C14.1094 5.95378 14.1549 5.75684 14.2461 5.57129C14.3405 5.38574 14.4723 5.22135 14.6416 5.07812C14.8141 4.9349 15.0208 4.82259 15.2617 4.74121C15.5026 4.65983 15.7712 4.61914 16.0674 4.61914C16.4906 4.61914 16.8519 4.69401 17.1514 4.84375C17.4508 4.99349 17.6803 5.19368 17.8398 5.44434C17.9993 5.69173 18.0791 5.9668 18.0791 6.26953H17.1758C17.1758 6.12305 17.1318 5.98145 17.0439 5.84473C16.9593 5.70475 16.834 5.58919 16.668 5.49805C16.5052 5.4069 16.305 5.36133 16.0674 5.36133C15.8167 5.36133 15.6133 5.40039 15.457 5.47852C15.304 5.55339 15.1917 5.64941 15.1201 5.7666C15.0518 5.88379 15.0176 6.00749 15.0176 6.1377C15.0176 6.23535 15.0339 6.32324 15.0664 6.40137C15.1022 6.47624 15.1641 6.54622 15.252 6.61133C15.3398 6.67318 15.4635 6.73177 15.623 6.78711C15.7826 6.84245 15.986 6.89779 16.2334 6.95312C16.6663 7.05078 17.0228 7.16797 17.3027 7.30469C17.5827 7.44141 17.791 7.60905 17.9277 7.80762C18.0645 8.00618 18.1328 8.24707 18.1328 8.53027C18.1328 8.76139 18.084 8.97298 17.9863 9.16504C17.8919 9.3571 17.7536 9.52311 17.5713 9.66309C17.3923 9.7998 17.1774 9.90723 16.9268 9.98535C16.6794 10.0602 16.401 10.0977 16.0918 10.0977C15.6263 10.0977 15.2324 10.0146 14.9102 9.84863C14.5879 9.68262 14.3438 9.46777 14.1777 9.2041C14.0117 8.94043 13.9287 8.66211 13.9287 8.36914H14.8369C14.8499 8.61654 14.9215 8.81348 15.0518 8.95996C15.182 9.10319 15.3415 9.20573 15.5303 9.26758C15.7191 9.32617 15.9062 9.35547 16.0918 9.35547C16.3392 9.35547 16.5459 9.32292 16.7119 9.25781C16.8812 9.19271 17.0098 9.10319 17.0977 8.98926C17.1855 8.87533 17.2295 8.74512 17.2295 8.59863ZM19.0801 7.41699V7.30469C19.0801 6.92383 19.1354 6.57064 19.2461 6.24512C19.3568 5.91634 19.5163 5.63151 19.7246 5.39062C19.9329 5.14648 20.1852 4.95768 20.4814 4.82422C20.7777 4.6875 21.1097 4.61914 21.4775 4.61914C21.8486 4.61914 22.1823 4.6875 22.4785 4.82422C22.778 4.95768 23.0319 5.14648 23.2402 5.39062C23.4518 5.63151 23.613 5.91634 23.7236 6.24512C23.8343 6.57064 23.8896 6.92383 23.8896 7.30469V7.41699C23.8896 7.79785 23.8343 8.15104 23.7236 8.47656C23.613 8.80208 23.4518 9.08691 23.2402 9.33105C23.0319 9.57194 22.7796 9.76074 22.4834 9.89746C22.1904 10.0309 21.8584 10.0977 21.4873 10.0977C21.1162 10.0977 20.7826 10.0309 20.4863 9.89746C20.1901 9.76074 19.9362 9.57194 19.7246 9.33105C19.5163 9.08691 19.3568 8.80208 19.2461 8.47656C19.1354 8.15104 19.0801 7.79785 19.0801 7.41699ZM19.9834 7.30469V7.41699C19.9834 7.68066 20.0143 7.92969 20.0762 8.16406C20.138 8.39518 20.2308 8.60026 20.3545 8.7793C20.4814 8.95833 20.6393 9.09993 20.8281 9.2041C21.0169 9.30501 21.2367 9.35547 21.4873 9.35547C21.7347 9.35547 21.9512 9.30501 22.1367 9.2041C22.3255 9.09993 22.4818 8.95833 22.6055 8.7793C22.7292 8.60026 22.8219 8.39518 22.8838 8.16406C22.9489 7.92969 22.9814 7.68066 22.9814 7.41699V7.30469C22.9814 7.04427 22.9489 6.7985 22.8838 6.56738C22.8219 6.33301 22.7275 6.1263 22.6006 5.94727C22.4769 5.76497 22.3206 5.62174 22.1318 5.51758C21.9463 5.41341 21.7282 5.36133 21.4775 5.36133C21.2301 5.36133 21.012 5.41341 20.8232 5.51758C20.6377 5.62174 20.4814 5.76497 20.3545 5.94727C20.2308 6.1263 20.138 6.33301 20.0762 6.56738C20.0143 6.7985 19.9834 7.04427 19.9834 7.30469ZM26.0039 2.5V10H25.0957V2.5H26.0039ZM29.0605 9.18457L30.5059 4.7168H31.4287L29.5293 10H28.9238L29.0605 9.18457ZM27.8545 4.7168L29.3438 9.20898L29.4463 10H28.8408L26.9268 4.7168H27.8545ZM34.4219 10.0977C34.054 10.0977 33.7204 10.0358 33.4209 9.91211C33.1247 9.78516 32.8691 9.60775 32.6543 9.37988C32.4427 9.15202 32.2799 8.88184 32.166 8.56934C32.0521 8.25684 31.9951 7.91504 31.9951 7.54395V7.33887C31.9951 6.90918 32.0586 6.52669 32.1855 6.19141C32.3125 5.85286 32.485 5.56641 32.7031 5.33203C32.9212 5.09766 33.1686 4.92025 33.4453 4.7998C33.722 4.67936 34.0085 4.61914 34.3047 4.61914C34.6823 4.61914 35.0078 4.68424 35.2812 4.81445C35.5579 4.94466 35.7842 5.12695 35.96 5.36133C36.1357 5.59245 36.266 5.86589 36.3506 6.18164C36.4352 6.49414 36.4775 6.83594 36.4775 7.20703V7.6123H32.5322V6.875H35.5742V6.80664C35.5612 6.57227 35.5124 6.3444 35.4277 6.12305C35.3464 5.90169 35.2161 5.7194 35.0371 5.57617C34.8581 5.43294 34.6139 5.36133 34.3047 5.36133C34.0996 5.36133 33.9108 5.40527 33.7383 5.49316C33.5658 5.5778 33.4176 5.70475 33.2939 5.87402C33.1702 6.04329 33.0742 6.25 33.0059 6.49414C32.9375 6.73828 32.9033 7.01986 32.9033 7.33887V7.54395C32.9033 7.7946 32.9375 8.0306 33.0059 8.25195C33.0775 8.47005 33.18 8.66211 33.3135 8.82812C33.4502 8.99414 33.6146 9.12435 33.8066 9.21875C34.002 9.31315 34.2233 9.36035 34.4707 9.36035C34.7897 9.36035 35.0599 9.29525 35.2812 9.16504C35.5026 9.03483 35.6963 8.86068 35.8623 8.64258L36.4092 9.07715C36.2952 9.24967 36.1504 9.41406 35.9746 9.57031C35.7988 9.72656 35.5824 9.85352 35.3252 9.95117C35.0713 10.0488 34.7702 10.0977 34.4219 10.0977ZM40.8623 8.97461V2.5H41.7705V10H40.9404L40.8623 8.97461ZM37.3076 7.41699V7.31445C37.3076 6.91081 37.3564 6.5446 37.4541 6.21582C37.555 5.88379 37.6966 5.59896 37.8789 5.36133C38.0645 5.1237 38.2842 4.94141 38.5381 4.81445C38.7952 4.68424 39.0817 4.61914 39.3975 4.61914C39.7295 4.61914 40.0192 4.67773 40.2666 4.79492C40.5173 4.90885 40.7288 5.0765 40.9014 5.29785C41.0771 5.51595 41.2155 5.77962 41.3164 6.08887C41.4173 6.39811 41.4873 6.74805 41.5264 7.13867V7.58789C41.4906 7.97526 41.4206 8.32357 41.3164 8.63281C41.2155 8.94206 41.0771 9.20573 40.9014 9.42383C40.7288 9.64193 40.5173 9.80957 40.2666 9.92676C40.016 10.0407 39.723 10.0977 39.3877 10.0977C39.0785 10.0977 38.7952 10.0309 38.5381 9.89746C38.2842 9.764 38.0645 9.57682 37.8789 9.33594C37.6966 9.09505 37.555 8.81185 37.4541 8.48633C37.3564 8.15755 37.3076 7.80111 37.3076 7.41699ZM38.2158 7.31445V7.41699C38.2158 7.68066 38.2419 7.92806 38.2939 8.15918C38.3493 8.3903 38.4339 8.59375 38.5479 8.76953C38.6618 8.94531 38.8066 9.08366 38.9824 9.18457C39.1582 9.28223 39.3682 9.33105 39.6123 9.33105C39.9118 9.33105 40.1576 9.26758 40.3496 9.14062C40.5449 9.01367 40.7012 8.84603 40.8184 8.6377C40.9355 8.42936 41.0267 8.20312 41.0918 7.95898V6.78223C41.0527 6.60319 40.9958 6.43066 40.9209 6.26465C40.8493 6.09538 40.7549 5.94564 40.6377 5.81543C40.5238 5.68197 40.3822 5.57617 40.2129 5.49805C40.0469 5.41992 39.8499 5.38086 39.6221 5.38086C39.3747 5.38086 39.1615 5.43294 38.9824 5.53711C38.8066 5.63802 38.6618 5.77799 38.5479 5.95703C38.4339 6.13281 38.3493 6.33789 38.2939 6.57227C38.2419 6.80339 38.2158 7.05078 38.2158 7.31445Z"
        fill="#ADB89B"
      />
    </g>
    <defs>
      <clipPath id="clip0_2401_22940">
        <rect width="46" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Data = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.334 2.75H3.66732C2.65898 2.75 1.83398 3.575 1.83398 4.58333V17.4167C1.83398 18.425 2.65898 19.25 3.66732 19.25H18.334C19.3423 19.25 20.1673 18.425 20.1673 17.4167V4.58333C20.1673 3.575 19.3423 2.75 18.334 2.75ZM18.334 17.4167H3.66732V4.58333H18.334V17.4167Z"
        fill="#0042AB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7925 9.55167L16.4908 8.25L13.585 11.1558L12.2925 9.85417L11 11.1467L13.585 13.75L17.7925 9.55167Z"
        fill="#0042AB"
      />
      <path
        d="M9.16732 6.41602H4.58398V8.24935H9.16732V6.41602Z"
        fill="#0042AB"
      />
      <path
        d="M9.16732 10.084H4.58398V11.9173H9.16732V10.084Z"
        fill="#0042AB"
      />
      <path d="M9.16732 13.75H4.58398V15.5833H9.16732V13.75Z" fill="#0042AB" />
    </g>
  </svg>
);

export const HistoryIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 72 56"
    className="cpp-ui-icon cpp-icon-history"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64 28C64 43.439 51.439 56 36 56C20.561 56 8 43.439 8 28C8 20.89 10.681 14.146 15.445 9H12V5H22V15H18V12.132C14.155 16.488 12 22.098 12 28C12 41.234 22.766 52 36 52C49.234 52 60 41.234 60 28C60 14.766 49.234 4 36 4V0C51.439 0 64 12.561 64 28ZM34.342 29.119L34.355 29.138L34.357 29.137C34.718 29.658 35.318 30 36 30C37.105 30 38 29.105 38 28V18H34V21.597L28.645 13.861L25.356 16.137L34.342 29.116V29.119Z"
      fill="#002869"
    />
  </svg>
);

export const Bold = () => (
  <svg
    width="7"
    height="9"
    viewBox="0 0 7 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.47447 9H0V0H4.11167C4.59644 2.98243e-05 5.07108 0.143476 5.47951 0.413393C5.88793 0.68331 6.21309 1.06842 6.41656 1.52323C6.62003 1.97803 6.69331 2.48353 6.62775 2.98001C6.56219 3.47649 6.36052 3.94319 6.04658 4.325C6.45664 4.66398 6.75497 5.12601 6.90051 5.64748C7.04604 6.16896 7.03161 6.72424 6.85922 7.23689C6.68682 7.74954 6.36494 8.19436 5.93786 8.5101C5.51079 8.82585 4.99953 8.997 4.47447 9ZM1.45118 7.5H4.46479C4.60772 7.5 4.74925 7.4709 4.8813 7.41436C5.01335 7.35783 5.13333 7.27496 5.23439 7.1705C5.33546 7.06603 5.41563 6.94201 5.47033 6.80552C5.52502 6.66903 5.55317 6.52274 5.55317 6.375C5.55317 6.22726 5.52502 6.08097 5.47033 5.94448C5.41563 5.80799 5.33546 5.68397 5.23439 5.5795C5.13333 5.47504 5.01335 5.39217 4.8813 5.33564C4.74925 5.2791 4.60772 5.25 4.46479 5.25H1.45118V7.5ZM1.45118 3.75H4.11167C4.2546 3.75 4.39613 3.7209 4.52818 3.66436C4.66023 3.60783 4.78021 3.52496 4.88127 3.4205C4.98234 3.31603 5.06251 3.19201 5.11721 3.05552C5.1719 2.91903 5.20006 2.77274 5.20006 2.625C5.20006 2.47726 5.1719 2.33097 5.11721 2.19448C5.06251 2.05799 4.98234 1.93397 4.88127 1.8295C4.78021 1.72504 4.66023 1.64217 4.52818 1.58564C4.39613 1.5291 4.2546 1.5 4.11167 1.5H1.45118V3.75Z"
      fill="#535353"
    />
  </svg>
);

export const Italic = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.875 0.875V0H2.1875V0.875H4.43625L2.52438 7H0V7.875H5.6875V7H3.43875L5.35063 0.875H7.875Z"
      fill="#535353"
    />
  </svg>
);

export const Underline = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 9.75H10.5V10.5H1.5V9.75ZM6 8.625C5.30381 8.625 4.63613 8.34844 4.14384 7.85616C3.65156 7.36387 3.375 6.69619 3.375 6V1.875H4.125V6C4.125 6.49728 4.32254 6.97419 4.67417 7.32583C5.02581 7.67746 5.50272 7.875 6 7.875C6.49728 7.875 6.97419 7.67746 7.32583 7.32583C7.67746 6.97419 7.875 6.49728 7.875 6V1.875H8.625V6C8.625 6.69619 8.34844 7.36387 7.85616 7.85616C7.36387 8.34844 6.69619 8.625 6 8.625Z"
      fill="#535353"
    />
  </svg>
);

export const Link = () => (
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2951 0.690391C11.0725 0.471561 10.808 0.29793 10.5167 0.179458C10.2254 0.0609849 9.91307 0 9.59767 0C9.28226 0 8.96996 0.0609849 8.67867 0.179458C8.38737 0.29793 8.12282 0.471561 7.90018 0.690391L8.46734 1.24592C8.61604 1.10027 8.79257 0.984734 8.98686 0.905909C9.18114 0.827085 9.38937 0.786514 9.59966 0.786514C9.80995 0.786514 10.0182 0.827085 10.2125 0.905909C10.4068 0.984734 10.5833 1.10027 10.732 1.24592C10.8807 1.39157 10.9986 1.56448 11.0791 1.75478C11.1596 1.94507 11.201 2.14904 11.201 2.35501C11.201 2.56099 11.1596 2.76495 11.0791 2.95525C10.9986 3.14555 10.8807 3.31846 10.732 3.46411L7.53672 6.59384C7.23694 6.88799 6.83014 7.05345 6.40581 7.05381C5.98149 7.05418 5.57439 6.88943 5.27408 6.59579C4.97377 6.30216 4.80485 5.90371 4.80447 5.48808C4.8041 5.07246 4.9723 4.67371 5.27208 4.37956L5.83525 3.82403L5.27208 3.2685L4.70492 3.82403C4.48151 4.0421 4.30425 4.30123 4.18329 4.58654C4.06234 4.87186 4.00008 5.17776 4.00008 5.4867C4.00008 5.79563 4.06234 6.10153 4.18329 6.38685C4.30425 6.67217 4.48151 6.93129 4.70492 7.14936C5.15685 7.58635 5.76738 7.82978 6.40241 7.82617C6.71902 7.82744 7.03276 7.76725 7.32549 7.64907C7.61822 7.53089 7.88413 7.35706 8.10788 7.13763L11.3031 4.0079C11.7509 3.56675 12.0015 2.96956 12 2.34753C11.9985 1.72549 11.745 1.12947 11.2951 0.690391Z"
      fill="#535353"
    />
    <path
      d="M1.28599 7.75575C1.13685 7.61034 1.01851 7.43751 0.937753 7.24718C0.856999 7.05685 0.815428 6.85277 0.815428 6.64665C0.815428 6.44054 0.856999 6.23646 0.937753 6.04612C1.01851 5.85579 1.13685 5.68296 1.28599 5.53756L4.48126 2.40783C4.6297 2.26175 4.80616 2.14583 5.00047 2.06673C5.19479 1.98763 5.40315 1.94691 5.61358 1.94691C5.82401 1.94691 6.03236 1.98763 6.22668 2.06673C6.421 2.14583 6.59745 2.26175 6.7459 2.40783C6.8941 2.55438 7.01076 2.72857 7.08897 2.92009C7.16718 3.11161 7.20535 3.31656 7.20122 3.52279C7.20244 3.72967 7.16177 3.93473 7.08155 4.12611C7.00134 4.31749 6.88318 4.49139 6.73391 4.63776L5.88717 5.47887L6.45433 6.0344L7.30107 5.20502C7.7518 4.76354 8.00502 4.16475 8.00502 3.5404C8.00502 2.91604 7.7518 2.31726 7.30107 1.87577C6.85034 1.43429 6.23902 1.18627 5.60159 1.18627C4.96417 1.18627 4.35284 1.43429 3.90211 1.87577L0.706854 5.0055C0.48284 5.22364 0.305067 5.48301 0.183759 5.76869C0.0624502 6.05437 0 6.36072 0 6.67013C0 6.97953 0.0624502 7.28588 0.183759 7.57156C0.305067 7.85724 0.48284 8.11661 0.706854 8.33475C1.16171 8.7684 1.77363 9.00759 2.40833 8.99982C3.04862 9.00041 3.66316 8.75289 4.11779 8.31128L3.55064 7.75575C3.40219 7.90183 3.22574 8.01775 3.03142 8.09685C2.8371 8.17595 2.62874 8.21667 2.41831 8.21667C2.20789 8.21667 1.99953 8.17595 1.80521 8.09685C1.61089 8.01775 1.43444 7.90183 1.28599 7.75575Z"
      fill="#535353"
    />
  </svg>
);

export const OrderedList = () => (
  <svg
    width="13"
    height="11"
    viewBox="0 0 13 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 8.25H13V9.16667H6V8.25ZM6 1.83333H13V2.75H6V1.83333ZM2 3.66667V0H1V0.458333H0V1.375H1V3.66667H0V4.58333H3V3.66667H2ZM3 11H0V9.16667C0 8.92355 0.105357 8.69039 0.292893 8.51849C0.48043 8.34658 0.734784 8.25 1 8.25H2V7.33333H0V6.41667H2C2.26522 6.41667 2.51957 6.51324 2.70711 6.68515C2.89464 6.85706 3 7.09022 3 7.33333V8.25C3 8.49312 2.89464 8.72627 2.70711 8.89818C2.51957 9.07009 2.26522 9.16667 2 9.16667H1V10.0833H3V11Z"
      fill="#535353"
    />
  </svg>
);

export const UnonorderedList = () => (
  <svg
    width="11"
    height="9"
    viewBox="0 0 11 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.26923 2.7C1.97021 2.7 2.53846 2.09558 2.53846 1.35C2.53846 0.604416 1.97021 0 1.26923 0C0.568254 0 0 0.604416 0 1.35C0 2.09558 0.568254 2.7 1.26923 2.7Z"
      fill="#535353"
    />
    <path
      d="M1.26923 9C1.97021 9 2.53846 8.39558 2.53846 7.65C2.53846 6.90442 1.97021 6.3 1.26923 6.3C0.568254 6.3 0 6.90442 0 7.65C0 8.39558 0.568254 9 1.26923 9Z"
      fill="#535353"
    />
    <path
      d="M5.07692 7.2H11V8.1H5.07692V7.2ZM5.07692 0.9H11V1.8H5.07692V0.9Z"
      fill="#535353"
    />
  </svg>
);

export const AddAbove = () => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4741_31978)">
      <path
        d="M2 3C1.44772 3 1 3.44772 1 4V5C1 5.55228 1.44772 6 2 6H8C8.55228 6 9 5.55228 9 5V4C9 3.44772 8.55228 3 8 3"
        stroke="#757575"
        stroke-width="0.7"
      />
      <path
        d="M4.50085 4.5V0H5.3962V4.5H4.50085ZM2.7002 2.696V1.80066H7.2002V2.696H2.7002Z"
        fill="#757575"
      />
    </g>
    <defs>
      <clipPath id="clip0_4741_31978">
        <rect width="10" height="7" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AddBelow = () => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4741_31989)">
      <path
        d="M2 4C1.44772 4 1 3.55228 1 3V2C1 1.44772 1.44772 1 2 1H8C8.55228 1 9 1.44772 9 2V3C9 3.55228 8.55228 4 8 4"
        stroke="#757575"
        stroke-width="0.7"
      />
      <path
        d="M4.50085 2.5V7H5.3962V2.5H4.50085ZM2.7002 4.304V5.19934H7.2002V4.304H2.7002Z"
        fill="#757575"
      />
    </g>
    <defs>
      <clipPath id="clip0_4741_31989">
        <rect
          width="10"
          height="7"
          fill="white"
          transform="matrix(1 0 0 -1 0 7)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MoveTo = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.9998 11V1M5.9998 1L4.7998 2.2M5.9998 1L7.1998 2.2"
      stroke="#757575"
      stroke-width="0.75"
    />
    <path
      d="M5.9998 1V11M5.9998 11L4.7998 9.8M5.9998 11L7.1998 9.8"
      stroke="#757575"
      stroke-width="0.75"
    />
    <path
      d="M11 6.0002L1 6.0002M1 6.0002L2.2 7.2002M1 6.0002L2.2 4.8002"
      stroke="#757575"
      stroke-width="0.75"
    />
    <path
      d="M1 6.0002L11 6.0002M11 6.0002L9.8 7.2002M11 6.0002L9.8 4.8002"
      stroke="#757575"
      stroke-width="0.75"
    />
  </svg>
);

export const MoveToTop = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4716_32509)">
      <path
        d="M6.73658 4.49121L3.36816 7.85963L4.15974 8.65121L6.73658 6.07998L9.31343 8.65121L10.105 7.85963L6.73658 4.49121Z"
        fill="#757575"
      />
    </g>
    <g clip-path="url(#clip1_4716_32509)">
      <path
        d="M6.73658 7.01758L3.36816 10.386L4.15974 11.1776L6.73658 8.60635L9.31343 11.1776L10.105 10.386L6.73658 7.01758Z"
        fill="#757575"
      />
    </g>
    <defs>
      <clipPath id="clip0_4716_32509">
        <rect width="13.4737" height="13.4737" fill="white" />
      </clipPath>
      <clipPath id="clip1_4716_32509">
        <rect
          width="13.4737"
          height="13.4737"
          fill="white"
          transform="translate(0 2.52637)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MoveToBottom = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4716_32512)">
      <path
        d="M6.73658 11.5088L3.36816 8.14037L4.15974 7.34879L6.73658 9.92002L9.31343 7.34879L10.105 8.14037L6.73658 11.5088Z"
        fill="#757575"
      />
    </g>
    <g clip-path="url(#clip1_4716_32512)">
      <path
        d="M6.73658 8.98242L3.36816 5.614L4.15974 4.82242L6.73658 7.39365L9.31343 4.82242L10.105 5.614L6.73658 8.98242Z"
        fill="#757575"
      />
    </g>
    <defs>
      <clipPath id="clip0_4716_32512">
        <rect
          width="13.4737"
          height="13.4737"
          fill="white"
          transform="matrix(1 0 0 -1 0 16)"
        />
      </clipPath>
      <clipPath id="clip1_4716_32512">
        <rect
          width="13.4737"
          height="13.4737"
          fill="white"
          transform="matrix(1 0 0 -1 0 13.4736)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const TrashSmallGrey = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M8.28653 4.13797L7.3472 4.10352L7.14355 9.66486L8.08288 9.69917L8.28653 4.13797Z"
        fill="#757575"
      />
      <path
        d="M6.46972 4.12012H5.52979V9.68149H6.46972V4.12012Z"
        fill="#757575"
      />
      <path
        d="M4.85587 9.6639L4.65222 4.10254L3.71289 4.13702L3.91656 9.69835L4.85587 9.6639Z"
        fill="#757575"
      />
      <path
        d="M0.407227 1.80176V2.7417H1.38666L2.16366 11.5714C2.18496 11.8141 2.38816 12.0002 2.63175 12.0002H9.35222C9.59583 12.0002 9.79917 11.8139 9.82031 11.5713L10.5973 2.7417H11.5926V1.80176H0.407227ZM8.92174 11.0603H3.06211L2.3302 2.7417H9.65381L8.92174 11.0603Z"
        fill="#757575"
      />
      <path
        d="M7.53493 0H4.46443C4.03253 0 3.68115 0.351375 3.68115 0.783281V2.27154H4.62109V0.939937H7.37827V2.27154H8.31821V0.783281C8.31821 0.351375 7.96683 0 7.53493 0Z"
        fill="#757575"
      />
      <path
        d="M7.53493 0H4.46443C4.03253 0 3.68115 0.351375 3.68115 0.783281V2.27154H4.62109V0.939937H7.37827V2.27154H8.31821V0.783281C8.31821 0.351375 7.96683 0 7.53493 0Z"
        stroke="#757575"
      />
    </g>
  </svg>
);

export const ContentMetricsIcon = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4609_31631)">
      <path
        d="M22.1667 3.5H5.83333C4.55 3.5 3.5 4.55 3.5 5.83333V22.1667C3.5 23.45 4.55 24.5 5.83333 24.5H22.1667C23.45 24.5 24.5 23.45 24.5 22.1667V5.83333C24.5 4.55 23.45 3.5 22.1667 3.5ZM10.5 19.8333H8.16667V11.6667H10.5V19.8333ZM15.1667 19.8333H12.8333V8.16667H15.1667V19.8333ZM19.8333 19.8333H17.5V15.1667H19.8333V19.8333Z"
        fill="#009AD7"
      />
    </g>
    <defs>
      <clipPath id="clip0_4609_31631">
        <rect width="27" height="27" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const KeepActiveSymbol = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.0417 10.1417L10.1422 0.242188L0.242676 10.1417L10.1422 20.0412L20.0417 10.1417ZM17.1426 10.0102L12.8999 5.76758L11.4857 7.18179L13.4026 9.09869H6.73906L8.65596 7.18179L7.24174 5.76758L4.41332 8.596L2.9991 10.0102L4.41332 11.4244L7.24174 14.2529L8.65596 12.8386L6.91601 11.0987H13.2253L11.4853 12.8387L12.8995 14.2529L15.7282 11.4242L15.7284 11.4244L17.1426 10.0102Z"
      fill="#0052D6"
    />
  </svg>
);

export const ArchiveSymbol = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.54 2.23L16.15 0.55C15.88 0.21 15.47 0 15 0H3C2.53 0 2.12 0.21 1.84 0.55L0.46 2.23C0.17 2.57 0 3.02 0 3.5V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V3.5C18 3.02 17.83 2.57 17.54 2.23ZM3.24 2H14.76L15.57 2.97H2.44L3.24 2ZM2 16V5H16V16H2ZM10.45 7H7.55V10H5L9 14L13 10H10.45V7Z"
      fill="#ED6926"
    />
  </svg>
);

export const Maintenance = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="10"
      width="14.1421"
      height="14.1421"
      transform="rotate(-45 0 10)"
      fill="#00A3DA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.65976 7.91996C4.6861 7.43468 4.83297 6.96555 5.08469 6.55405L6.70639 8.17575L7.6597 7.22244L6.03504 5.59778C6.49911 5.30857 7.03764 5.15506 7.589 5.15858L7.5779 5.15858C7.96145 5.1586 8.34125 5.23415 8.69561 5.38093C9.05001 5.52773 9.37203 5.74289 9.64327 6.01414C9.91452 6.28539 10.1297 6.6074 10.2765 6.9618C10.4233 7.3162 10.4988 7.69604 10.4988 8.07964C10.4984 8.22128 10.4882 8.36263 10.4682 8.50267L10.1914 9.33305L14.1912 13.3329L14.1824 13.3417C14.4672 13.7328 14.4331 14.2837 14.0803 14.6365C13.7274 14.9894 13.1765 15.0234 12.7855 14.7387L12.777 14.7471L12.682 14.6521L12.6661 14.6365L12.6505 14.6206L8.77716 10.7473L7.80427 10.9905C7.34269 11.0266 6.87708 10.9526 6.44657 10.772C5.89097 10.5389 5.42103 10.1397 5.10114 9.62917C4.78126 9.11859 4.62709 8.52158 4.65976 7.91996ZM13.5853 14.1416C13.7806 13.9464 13.7806 13.6298 13.5853 13.4345C13.39 13.2393 13.0734 13.2393 12.8782 13.4345C12.6829 13.6298 12.6829 13.9464 12.8782 14.1416C13.0734 14.3369 13.39 14.3369 13.5853 14.1416Z"
      fill="white"
    />
  </svg>
);

export const Pencil = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6137_36661)">
      <path
        d="M1.25 7.18756V8.75006H2.8125L7.42083 4.14173L5.85833 2.57923L1.25 7.18756ZM8.62917 2.9334C8.79167 2.7709 8.79167 2.5084 8.62917 2.3459L7.65417 1.3709C7.49167 1.2084 7.22917 1.2084 7.06667 1.3709L6.30417 2.1334L7.86667 3.6959L8.62917 2.9334Z"
        fill="#0042AB"
      />
    </g>
    <defs>
      <clipPath id="clip0_6137_36661">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LargePencil = () => (
  <svg
    width="15"
    height="15"
    scale="1.5"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6137_36661)">
      <path
        d="M1.25 7.18756V8.75006H2.8125L7.42083 4.14173L5.85833 2.57923L1.25 7.18756ZM8.62917 2.9334C8.79167 2.7709 8.79167 2.5084 8.62917 2.3459L7.65417 1.3709C7.49167 1.2084 7.22917 1.2084 7.06667 1.3709L6.30417 2.1334L7.86667 3.6959L8.62917 2.9334Z"
        fill="#0042AB"
      />
    </g>
    <defs>
      <clipPath id="clip0_6137_36661">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Revert = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6110_39188)">
      <path
        d="M6 2.5V0.5L3.5 3L6 5.5V3.5C7.655 3.5 9 4.845 9 6.5C9 8.155 7.655 9.5 6 9.5C4.345 9.5 3 8.155 3 6.5H2C2 8.71 3.79 10.5 6 10.5C8.21 10.5 10 8.71 10 6.5C10 4.29 8.21 2.5 6 2.5Z"
        fill="#0042AB"
      />
    </g>
    <defs>
      <clipPath id="clip0_6110_39188">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BackTag = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6797_47429)">
      <path
        d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3Z"
        fill="#009AD7"
      />
    </g>
    <defs>
      <clipPath id="clip0_6797_47429">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Eye = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_11722_87062)">
      <path
        d="M6.49935 3.52083C8.55227 3.52083 10.3831 4.67458 11.2768 6.5C10.3831 8.32542 8.55768 9.47917 6.49935 9.47917C4.44102 9.47917 2.6156 8.32542 1.72185 6.5C2.6156 4.67458 4.44643 3.52083 6.49935 3.52083ZM6.49935 2.4375C3.79102 2.4375 1.4781 4.12208 0.541016 6.5C1.4781 8.87792 3.79102 10.5625 6.49935 10.5625C9.20768 10.5625 11.5206 8.87792 12.4577 6.5C11.5206 4.12208 9.20768 2.4375 6.49935 2.4375ZM6.49935 5.14583C7.24685 5.14583 7.85352 5.7525 7.85352 6.5C7.85352 7.2475 7.24685 7.85417 6.49935 7.85417C5.75185 7.85417 5.14518 7.2475 5.14518 6.5C5.14518 5.7525 5.75185 5.14583 6.49935 5.14583ZM6.49935 4.0625C5.15602 4.0625 4.06185 5.15667 4.06185 6.5C4.06185 7.84333 5.15602 8.9375 6.49935 8.9375C7.84268 8.9375 8.93685 7.84333 8.93685 6.5C8.93685 5.15667 7.84268 4.0625 6.49935 4.0625Z"
        fill="#0052D6"
      />
    </g>
    <defs>
      <clipPath id="clip0_11722_87062">
        <rect width="13" height="13" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EyeOff = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_0_1)">
      <path
        d="M6.49935 4.52083C8.55227 4.52083 10.3831 5.67458 11.2768 7.5C10.3831 9.32542 8.55768 10.4792 6.49935 10.4792C4.44102 10.4792 2.6156 9.32542 1.72185 7.5C2.6156 5.67458 4.44643 4.52083 6.49935 4.52083ZM6.49935 3.4375C3.79102 3.4375 1.4781 5.12208 0.541016 7.5C1.4781 9.87792 3.79102 11.5625 6.49935 11.5625C9.20768 11.5625 11.5206 9.87792 12.4577 7.5C11.5206 5.12208 9.20768 3.4375 6.49935 3.4375ZM6.49935 6.14583C7.24685 6.14583 7.85352 6.7525 7.85352 7.5C7.85352 8.2475 7.24685 8.85417 6.49935 8.85417C5.75185 8.85417 5.14518 8.2475 5.14518 7.5C5.14518 6.7525 5.75185 6.14583 6.49935 6.14583ZM6.49935 5.0625C5.15602 5.0625 4.06185 6.15667 4.06185 7.5C4.06185 8.84333 5.15602 9.9375 6.49935 9.9375C7.84268 9.9375 8.93685 8.84333 8.93685 7.5C8.93685 6.15667 7.84268 5.0625 6.49935 5.0625Z"
        fill="#0052D6"
      />
    </g>
    <line
      x1="9.46472"
      y1="0.17949"
      x2="4.43901"
      y2="13.2463"
      stroke="#0052D6"
    />
    <defs>
      <clipPath id="clip0_0_1">
        <rect width="13" height="13" fill="white" transform="translate(0 1)" />
      </clipPath>
    </defs>
  </svg>
);
